<template>
	<v-list v-if="options.length" class="q-comprehensive-checkboxes-filter" :style="computedStyle">
		<v-list-item v-for="item in computedOptions" :key="item.key" dense>
			<div class="q-comprehensive-checkboxes-filter__item"
				:class="{ 'q-comprehensive-checkboxes-filter__item--nested': item.nested }"
				@click="onClick(item)"
			>
				<div class="q-comprehensive-checkboxes-filter__checkbox" :class="{ 'item-checkbox--selected': item.selected }">
					<v-icon v-if="item.selected" color="white">
						icon-checkmark-q
					</v-icon>
				</div>
				<div class="q-comprehensive-checkboxes-filter__label">
					<slot name="label">
						<p class="q-comprehensive-checkboxes-filter__item-label">{{ item.label }}</p>
					</slot>
				</div>
			</div>
		</v-list-item>
	</v-list>
	<div v-else class="q-comprehensive-checkboxes-filter__item-label mt-2">There is no filter options</div>
</template>

<script>
const ALL = '-All-'

export default {
    props: {
        value: { type: String, default: '' },
        options: { type: Array },
		color: { type: String, default: 'primary' },
		valueKey: { type: String, default: 'value' },
        textKey: { type: String, default: 'text' },
    },
    data () {
        return {
        }
    },
    computed: {
		mValue: {
			get () {
				if (!this.value) { return [] }
				return this.value.split(',').map(item => item.trim())
			},
			set (val) {
				if (!val?.length) {
					this.$emit('input', '')
				} else {
					this.$emit('input', val.join(','))
				}
			},
		},
		computedOptions () {
			if (!this.options) { return null }
			return this.options.map((item) => {
				if (typeof item === 'object') {
					return {
						key: item[this.valueKey],
						value: item[this.valueKey],
						label: item[this.textKey],
						selected: this.mValue.includes(item[this.valueKey]),
						exclusiveGroup: item.exclusiveGroup,
						exclusiveOf: item.exclusiveOf,
						parentOfGroup: item.parentOfGroup,
						nested: item.nested,
					}
				}
				return {
					key: item,
					value: item,
					label: item,
					selected: this.mValue.includes(item),
				}
			})
		},
		hasAllValue () {
			return this.computedOptions.some(({ value}) => value === ALL)
		},
		computedStyle () {
			const color = this.color === 'primary' ? '#46C3B2' : this.color
			return {
				'--comprehensive-checkboxes-color': color,
			}
		},
    },
    methods: {
		onClick (option) {
			if (option.value === ALL) {
				if (!this.mValue.includes(ALL)) {
					this.mValue = [ALL]
				}
				return
			}

			if (this.mValue.includes(option.value)) {
				this.deselect(option)
				return
			}
			
			this.select(option)
		},
		select (option) {
			this.mValue = this.computedOptions
			    .filter((item) => this.isSelected(item, option))
				.map((item) => item.value)
		},
		deselect (option) {
			if (this.mValue.length === 1 || option.parentOfGroup) {
				this.mValue = [ALL]
				return
			}
			
			this.mValue = this.mValue.filter((value) => value !== option.value)
		},
		isSelected (item, option) {
			if (item.value === option.value) { return true }
			if (item.value === ALL) { return false }
			if (option.exclusiveGroup && item.parentOfGroup === option.exclusiveGroup) { return true }
			if (option.exclusiveGroup && item.exclusiveOf === option.exclusiveGroup) { return false }
			if (option.exclusiveOf && item.exclusiveGroup === option.exclusiveOf) { return false }
			return this.mValue.includes(item.value)
		},
	},
}
</script>

<style lang="scss" scoped>
.q-comprehensive-checkboxes-filter {
	.v-list-item {
		padding: 0 0.5rem;
		min-height: 32px;
		border-radius: 6px;

		&::after {
			content: '';
			position: absolute;
			inset: 0;
			border-radius: inherit;
			background-color: rgba(0, 0, 0, 0.87);
			opacity: 0;
			pointer-events: none;
			transition: opacity 0.2s;
		}

		&:hover::after {
			opacity: 0.04;
		}
	}

	.q-comprehensive-checkboxes-filter__item {
		position: relative;
		display: flex;
		align-items: center;
		cursor: pointer;
		width: 100%;
		border-radius: 8px;
	}

	.q-comprehensive-checkboxes-filter__checkbox {
		$size: 20px;
		width: $size;
		height: $size;
		margin-right: 0.5rem;
		display: flex;
		align-items: center;
		justify-content: center;
		border: 2px solid #D0D0D0;
		border-radius: 4px;

		.v-icon.v-icon {
			font-size: $size - 2px !important;
		}
	}

	.item-checkbox--selected {
		border: none;
		background-color: var(--comprehensive-checkboxes-color);
	}

	.q-comprehensive-checkboxes-filter__item-label {
		margin: 0;
		line-height: 1;
		font-size: 1rem;
		color: #2F2F2F;
	}

	.q-comprehensive-checkboxes-filter__item--nested {
		padding-left: 1rem;
	}
}
</style>
